import { useAppContext } from 'context/app-context'
import { Container } from 'components/container'
import HeaderImage from 'assets/illustration-v2.1.jpg'
import ScrollDownButton from './scroll-down-button'
import {
  StyledHeader,
  Image,
  Intro,
  TextContent,
  Title,
  Content,
} from './styled'

export const Header = () => {
  const { strings } = useAppContext()

  return (
    <>
      <StyledHeader>
        <Content>
          <Container>
            <Image src={HeaderImage} alt="" />
            <TextContent>
              <Title>{strings.title}</Title>
              <Intro>
                <p>{strings.intro}</p>
              </Intro>
            </TextContent>
          </Container>
        </Content>
      </StyledHeader>
      <ScrollDownButton
        onClick={() =>
          window.scrollBy({ top: window.innerHeight - window.scrollY })
        }
      />
    </>
  )
}
